import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { HeaderComponent } from "./layout/header/header.component";
import { FooterComponent } from "./layout/footer/footer.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, HeaderComponent, FooterComponent, ToastModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'teachmate';
  isPortal = false;
  isHideFooter = false;

  constructor(
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Immediate check for portal state on refresh
    if (isPlatformBrowser(this.platformId)) {
      this.checkPortalStatus(window.location.pathname);
    }

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: any) => {
      this.checkPortalStatus(event.urlAfterRedirects);
    });
  }

  private checkPortalStatus(url: string): void {
    const portalPaths = [
      '/student', 
      '/tutor'
    ];
    this.isPortal = portalPaths.some(path => url === path || url.startsWith(path + '/'));
    this.isHideFooter = 
      url.startsWith('/tutor-signup') || 
      url === '/thank-you' || 
      url.startsWith('/bookings');
  }
}
